var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "rounded-0" },
    [
      _c(
        "h4",
        [
          _vm._v(_vm._s(_vm.title) + "\n    "),
          _c(
            "b-badge",
            { staticClass: "ml-2 px-3", attrs: { variant: "primary" } },
            [_vm._v(_vm._s(_vm.items.length))]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-link",
                  attrs: {
                    size: "md",
                    variant: "link",
                    "aria-controls": "collapseId",
                    "aria-expanded": _vm.showCollapse ? "true" : "false"
                  },
                  on: {
                    click: function($event) {
                      _vm.showCollapse = !_vm.showCollapse
                    }
                  }
                },
                [
                  !_vm.showCollapse
                    ? _c("span", { staticClass: "ti-angle-up" })
                    : _c("span", { staticClass: "ti-angle-down" })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: { id: _vm.collapseId },
          model: {
            value: _vm.showCollapse,
            callback: function($$v) {
              _vm.showCollapse = $$v
            },
            expression: "showCollapse"
          }
        },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              fields: _vm.fields,
              items: _vm.items,
              "tbody-tr-class": "show-cursor",
              "tbody-class": "text-muted"
            },
            scopedSlots: _vm._u([
              {
                key: "contractPartner.contractPartnerName",
                fn: function(row) {
                  return [
                    _c(
                      "div",
                      {
                        class: { "text-danger": !row.item.isComplete },
                        on: {
                          click: function($event) {
                            _vm.showDetails(row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            row.item.contractPartner
                              ? row.item.contractPartner.contractPartnerName
                              : ""
                          )
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "contractType",
                fn: function(row) {
                  return [
                    _c(
                      "div",
                      {
                        class: { "text-danger": !row.item.isComplete },
                        on: {
                          click: function($event) {
                            _vm.showDetails(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(row.item.contractType))]
                    )
                  ]
                }
              },
              {
                key: "cancellationPeriod",
                fn: function(row) {
                  return [
                    _c(
                      "div",
                      {
                        class: { "text-danger": !row.item.isComplete },
                        on: {
                          click: function($event) {
                            _vm.showDetails(row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getCancellationPeriodText(
                                row.item.cancellationPeriod
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.items || _vm.items.length === 0
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.contractsCard.noItems")) +
                    "\n    "
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58b540e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b540e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractsCard.vue
// module id = A34O
// module chunks = 1